<template>
  <!-- DUPLICATED from packages/frontend for the studio (intentional — see
       docs/superpowers/specs/2026-06-01-battleplan-authoring-tool-design.md §5).
       Keep rendering in sync with the frontend original when it changes.
       NOTE: App-specific deps removed: useTheme (colorMode), useHoliday (holiday),
       useSettings (settings), CherryBlossomCircleDecoration, christmasWreath asset.
       Those decorations are not needed for the editor's preview render. -->
  <div v-if="cost" class="cost-badge">
    <!-- Casting -->
    <div v-if="type === AbilityType.Spell" class="casting-value-container">
      <div class="casting-value-circle">
        <span class="casting-value-text">{{ cost }}</span>
      </div>
    </div>
    <!-- Chanting -->
    <div v-else-if="type === AbilityType.Prayer" class="chanting-value-container">
      <div class="chanting-value-diamond">
        <FontAwesomeIcon :icon="['fas', 'diamond']" class="diamond-bg" />
        <span class="diamond-chanting-text">{{ cost }}</span>
      </div>
    </div>
    <!-- Commanding -->
    <div v-else-if="type === AbilityType.Command" class="cost-hexagon-container">
      <div class="cost-hexagon-icon">
        <FontAwesomeIcon :icon="['fas', 'stop']" class="hexagon-bg" />
        <span class="hexagon-cost-text">{{ cost }}</span>
      </div>
    </div>
    <!-- Tithing -->
    <div v-if="type === AbilityType.BloodTithe" class="blood-tithe-icon">
      <span class="blood-tithe-text">{{ cost }}</span>
    </div>
    <!-- Fating -->
    <div v-if="type === AbilityType.Fate" class="fate-container">
      <FontAwesomeIcon :icon="'meteor'" class="fate-icon" />
      <div class="fate-circle"></div>
      <span :class="['fate-text', cost.length === 1 ? 'fts' : '']">{{ cost }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
// DUPLICATED from packages/frontend for the studio (intentional — see
// docs/superpowers/specs/2026-06-01-battleplan-authoring-tool-design.md §5).
// Keep rendering in sync with the frontend original when it changes.
import { AbilityType } from '@scrolldex/shared';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

defineProps<{ type: AbilityType; cost: string; name?: string }>();
</script>

<style lang="css" scoped>
.blood-tithe-icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.blood-tithe-text {
  position: absolute;
  right: 2.25em;
  color: #fff;
  font-weight: bold;
  font-size: 1.1em;
  pointer-events: none;
  text-shadow:
    0 1px 2px #fff,
    0 0 2px #fff;
  z-index: 40;
}
.casting-value-container {
  position: relative;
  width: 36px;
  height: 36px;
}
.fate-circle,
.casting-value-circle {
  background: var(--bg-primary);
  border: var(--border);
  color: var(--text-main);
  font-weight: bold;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1em;
  z-index: 2;
  box-shadow: var(--shadow);
}
.casting-value-text {
  z-index: 20;
}

.chanting-value-container {
  position: relative;
  width: 38px;
  height: 38px;
}

.chanting-value-diamond {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.diamond-bg {
  font-size: 2.2em;
  color: var(--bg-primary);
  stroke: var(--border-color);
  stroke-width: 20px;
  filter: drop-shadow(var(--shadow));
}

.diamond-chanting-text {
  position: absolute;
  color: var(--text-main);
  font-weight: bold;
  font-size: 1.1em;
  pointer-events: none;
  z-index: 20;
}

.cost-hexagon-container {
  position: relative;
  width: 38px;
  height: 38px;
}

.cost-hexagon-icon {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.hexagon-bg {
  font-size: 2.2em;
  color: var(--bg-primary);
  stroke: var(--border-color);
  stroke-width: 20px;
  filter: drop-shadow(var(--shadow));
}

.hexagon-cost-text {
  position: absolute;
  color: var(--text-main);
  font-weight: bold;
  font-size: 1.1em;
  pointer-events: none;
  z-index: 20;
}

.fate-container {
  position: relative;
  width: 2em;
  height: 2em;
}
.fate-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  top: -1em;
  left: -0.75em;
  z-index: 0;
  transform: scaleX(-1);
}
.fate-text {
  position: absolute;
  font-weight: bold;
  font-size: 1.1em;
  z-index: 20;
  pointer-events: none;
  top: 0.2em;
  left: 0.6em;
}
.fate-circle {
  position: absolute;
  top: 0em;
  left: 0.25em;
  width: 1.5em;
  height: 1.5em;
}
.fts {
  left: 0.8em;
}
</style>
